/**
 * defa.views.PhoneNumberSnippet
 * A view for a single selectable PhoneNumber.
 * @version 1.2.1
 */
import Snippet from 'scripts/poppet/snippet';

const PhoneNumberSnippet = Snippet.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	className: 'snippet phone',
	
	templateContext: function () {
		
		let superContext = Snippet.prototype.templateContext.call( this );
		
		return _.extend( superContext, {
			iconClass: 'icon icon-material icon-labelled icon-phone',
			header   : this.model.numberName(),
			hasDelete: true,
		} );
	},
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default PhoneNumberSnippet;